/* eslint-disable no-case-declarations */
import {
  SET_DASHBOARD_URLS, DASHBOARD_URLS_REQUEST_FAILED, SENDING_DASHBOARD_URLS_REQUEST,
} from '../../types/Types';

/** @type { Object } default state */
const defaultState = {
  dasboardURLsData: '',
  isDURLsSending: false,
  uRLsError: false,
  isURLsSuccess: false,
};

/**
 * dispatched the user data to the store
 * @param  { Object } state  default state
 * @param  { Object } action dispacthed action from middleware
 */
export default function getDashboardURLs(state = defaultState, action = {}) {
  switch (action.type) {
    case SET_DASHBOARD_URLS:
      const data = {};
      data.dasboardURLsData = action.dasboardURLsData;
      data.isDURLsSending = action.isDURLsSending;
      data.isURLsSuccess = action.isURLsSuccess;
      data.uRLsError = action.uRLsError;
      return { ...state, ...data };

    case SENDING_DASHBOARD_URLS_REQUEST:
      const sendingRequest = {};
      sendingRequest.dasboardURLsData = action.dasboardURLsData;
      sendingRequest.isDURLsSending = action.isDURLsSending;
      sendingRequest.isURLsSuccess = action.isURLsSuccess;
      sendingRequest.uRLsError = action.uRLsError;
      return { ...state, ...sendingRequest };

    case DASHBOARD_URLS_REQUEST_FAILED:
      const errors = {};
      errors.dasboardURLsData = action.dasboardURLsData;
      errors.isDURLsSending = action.isDURLsSending;
      errors.isURLsSuccess = action.isURLsSuccess;
      errors.uRLsError = action.uRLsError;
      errors.fMsg = action.fMsg;
      return { ...state, ...errors };
    default: return state;
  }
}
